import React from 'react';
import { Form, Button, Col, Row, Input } from 'antd';
import { UserAddressModel } from '../../../models/user';
import '../styles/index.css';

interface Props {
    initialValues: UserAddressModel | undefined
    onSubmit: (user: UserAddressModel) => void
    onClose: () => void
}
const AddressForm = (props: Props) => {
    const [form] = Form.useForm();

    const onFinish = (values: any) => {
        values._id = props.initialValues && props.initialValues._id;
        props.onSubmit(values);
    };

    return (
        <Form
            layout='vertical'
            hideRequiredMark
            initialValues={props.initialValues}
            form={form}
            onFinish={onFinish}
        >
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        name='name'
                        label='name'
                        rules={[{ required: true, message: 'Please enter name' }]}
                    >
                        <Input placeholder='Please enter name' />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name='phone'
                        label='Phone'
                        rules={[{ required: true, message: 'Please enter phone' }]}
                    >
                        <Input placeholder='Please enter phone' />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        name='area'
                        label='area'
                        rules={[{ required: true, message: 'Please enter area' }]}
                    >
                        <Input placeholder='Please enter area' />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name='details'
                        label='details'
                        rules={[{ required: true, message: 'Please enter details' }]}
                    >
                        <Input placeholder='Please enter details' />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={24} className='btn'>
                    <Form.Item>
                        <Button htmlType='button' onClick={props.onClose}>
                            Cancel
                        </Button>
                        <Button type='primary' htmlType='submit' className='submit'>
                            Submit
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};

export default AddressForm;
